/**
 * ProjectBadge — belge listelerinde cari adının altında görünen küçük proje etiketi.
 * Kolon kalabalığı oluşturmamak için ayrı kolon yerine mevcut hücreye yerleşir;
 * belge projeye bağlı değilse hiçbir şey çizilmez.
 */
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  projectName?: string | null;
}

const ProjectBadge: React.FC<Props> = ({ projectName }) => {
  const { t } = useTranslation('common2');

  if (!projectName) return null;

  return (
    <Tooltip title={`${t('projects.badge')}: ${projectName}`}>
      <Chip
        size="small"
        variant="outlined"
        color="info"
        label={projectName}
        sx={{
          mt: 0.25,
          height: 18,
          maxWidth: '100%',
          '& .MuiChip-label': { fontSize: '0.65rem', px: 0.75 },
        }}
      />
    </Tooltip>
  );
};

export default ProjectBadge;
